import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPencilFill';
/** Renders an SVG icon. */
const SvgPencilFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m25.424 4.167 1.409 1.409a3.985 3.985 0 0 1 0 5.635l-1.409 1.409a.996.996 0 0 1-1.409 0L18.38 6.985a.996.996 0 0 1 0-1.41l1.409-1.408a3.985 3.985 0 0 1 5.635 0m-9.862 4.227a.996.996 0 0 1 1.41 0l5.634 5.635a.995.995 0 0 1 0 1.409l-9.861 9.861a1 1 0 0 1-.51.273L5.193 26.98a.996.996 0 0 1-1.173-1.173l1.41-7.044a1 1 0 0 1 .272-.509l9.861-9.861Zm-5.542 15.59L7.017 20.98l-.75 3.754z"
      />
    </svg>
  );
};
SvgPencilFill.displayName = displayName;
export default SvgPencilFill;
